import React, { memo } from 'react';
import { Box, Icon } from '@betty/moonlight';
import { TabBarIconProps } from './TabBarIcon.types';

function TabBarIcon(props: TabBarIconProps) {
  return (
    <Box justifyContent="center" alignItems="center">
      <Icon alignSelf="center" {...props} />
    </Box>
  );
}

export default memo(TabBarIcon);
